<template>
  <v-list bg-color="transparent">
    <v-img
      max-width="80"
      class="mx-auto mt-5 mb-10"
      src="../assets/images/logo.svg"
    ></v-img>

    <v-list-item
      v-for="item in list"
      :key="item.text"
      :to="item.link"
      variant="contained"
    >
      <v-list-item-avatar start>
        <v-icon>{{ item.icon }}</v-icon>
      </v-list-item-avatar>
      <v-list-item-title>{{ item.text }}</v-list-item-title>
    </v-list-item>
  </v-list>
</template>
<script>
export default {
  name: "TheSidebar",
  data() {
    return {
      list: [
        {
          text: "Users",
          link: { name: "Users" },
          icon: "group",
        },
        {
          text: "Forests",
          link: { name: "Forests" },
          icon: "park",
        },
        {
          text: "Companies",
          link: { name: "Companies" },
          icon: "domain",
        },
        {
          text: "Visitors",
          link: { name: "Visitors" },
          icon: "visibility",
        },
        {
          text: "Emails",
          link: { name: "Emails" },
          icon: "email",
        },
        {
          text: "Trees",
          link: { name: "TreePlanting" },
          icon: "eco",
        },
        {
          text: "Orders",
          link: { name: "Orders" },
          icon: "shopping_cart",
        },
        {
          text: "Invoices",
          link: { name: "Invoices" },
          icon: "receipt",
        },
      ],
    };
  },
};
</script>
